import { IconWrapper } from '../runtime';
export default IconWrapper('application', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 2.0497C1.75 1.88401 1.88431 1.74969 2.05 1.74969H6.45C6.61569 1.74969 6.75 1.88401 6.75 2.04969V6.44969C6.75 6.61538 6.61569 6.74969 6.45 6.74969H2.05C1.88431 6.74969 1.75 6.61538 1.75 6.44969V2.0497Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M9.25 2.0497C9.25 1.88401 9.38431 1.74969 9.55 1.74969H13.95C14.1157 1.74969 14.25 1.88401 14.25 2.04969V6.44969C14.25 6.61538 14.1157 6.74969 13.95 6.74969H9.55C9.38431 6.74969 9.25 6.61538 9.25 6.44969V2.0497Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M1.75 9.5497C1.75 9.38401 1.88431 9.24969 2.05 9.24969H6.45C6.61569 9.24969 6.75 9.38401 6.75 9.5497V13.9497C6.75 14.1154 6.61569 14.2497 6.45 14.2497H2.05C1.88431 14.2497 1.75 14.1154 1.75 13.9497V9.5497Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M9.25 9.5497C9.25 9.38401 9.38431 9.24969 9.55 9.24969H13.95C14.1157 9.24969 14.25 9.38401 14.25 9.5497V13.9497C14.25 14.1154 14.1157 14.2497 13.95 14.2497H9.55C9.38431 14.2497 9.25 14.1154 9.25 13.9497V9.5497Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});